import API from "../../utils/APIUtils";

const authMiddleware = (storeAPI) => (next) => (action) => {
    const token = localStorage.getItem('objectId');
    if (token) {
      API.defaults.headers['Authorization'] = `Bearer ${token}`;
    }
    return next(action);
  };

  
  export default authMiddleware